<template>
	<v-dialog
		v-model="dialog"
		persistent
		width="1000"
	>
		<template #activator="{ props }">
			<v-btn
				v-if="orderrow.canUpdate"
				v-can="'order.policydetails.update'"
				size="small"
				block
				variant="outlined"
				color="primary"
				v-bind="props"
				@click="setNewValues"
			>
				<translate>Update</translate>
			</v-btn>
		</template>
		<v-card>
			<v-card-title>
				<translate>Update insured device</translate>
			</v-card-title>
			<v-card-text>
				<v-container>
					<v-row>
						<v-col
							cols="12"
							sm="6"
							md="4"
						>
							<v-text-field
								v-model="newEan"
								:label="$gettext('EAN')"
								variant="outlined"
							/>
						</v-col>
						<v-col
							cols="12"
							sm="6"
							md="4"
						>
							<v-select
								:items="[newProduct]"
								:label="$gettext('Insured product')"
								:model-value="newProduct"
								disabled
								variant="outlined"
							/>
						</v-col>
						<v-col
							cols="12"
							sm="6"
							md="4"
						>
							<v-btn
								location="top"
								color="primary"
								variant="text"
								@click="findDevice"
							>
								<translate>Find Device</translate>
							</v-btn>
						</v-col>
						<v-col
							cols="12"
							sm="6"
							md="4"
						>
							<v-text-field
								v-model="newPremium"
								disabled
								:label="$gettext('Premium')"
								variant="outlined"
							/>
						</v-col>
						<v-col
							cols="12"
							sm="6"
							md="4"
						>
							<v-text-field
								v-model="newSerialNumber"
								:label="$gettext('Serial Number')"
								variant="outlined"
							/>
						</v-col>
						<v-col
							cols="12"
							sm="6"
							md="4"
						>
							<v-text-field
								v-model="newImei"
								:label="$gettext('IMEI')"
								variant="outlined"
							/>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn
					variant="text"
					color="error"
					@click="resetNewValues"
				>
					<translate>Cancel</translate>
				</v-btn>
				<v-btn
					variant="text"
					color="primary"
					@click="updateInsuredDevice"
				>
					<translate>Save changes</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	displayError, inform,
} from 'laravel-front-library';
import {
	debounce,
} from 'lodash';

export default {
	name: 'UpdatePolicyDetails',

	props: {
		orderrow: {
			type: Object,
			required: true,
		}
	},

	data () {
		return {
			dialog: false,
			newEan: '',
			newDeviceId: '',
			newPremium: '',
			newSerialNumber: '',
			newImei: '',
			newProduct: ''
		};
	},

	methods: {
		/**
		 * Set the v-dialogue default values to those of the current item
		 *
		 */
		setNewValues () {
			this.newEan = this.orderrow.ean;
			this.newDeviceId = this.orderrow.deviceId;
			this.newPremium = this.orderrow.premium;
			this.newSerialNumber = this.orderrow.serialNumber;
			this.newImei = this.orderrow.imei;
			this.newProduct = this.orderrow.product;
		},

		/**
		 *
		 */
		resetNewValues () {
			this.newEan = '';
			this.newDeviceId = '';
			this.newPremium = '';
			this.newSerialNumber = '';
			this.newImei = '';
			this.newProduct = '';
			this.dialog = false;
		},

		/**
		 * Retrieve the price of the new device from the device id and the productversion id.
		 */
		retrievePrice () {
			axios.get(`/api/v0/prices?device=${this.newDeviceId}&productversion=${this.orderrow.productVersionId}`)
				.then(({
					data
				}) => {
					if (data.success) {
						this.newPremium = data.price;
					}
				}).catch(() => {
					displayError(this.$gettext('Something has gone wrong during price fetch'));
				});
		},

		/**
		 * To call the endpoint which gives the device with a given EAN.
		 *
		 * @returns {void}
		 */
		findDevice () {
			this.findDeviceLoading = true;
			axios.get('/bo/orders/device', {
				params: {
					ean: this.newEan,
				},
			})
				.then((response) => {
					this.newProduct = response.data.fullName;
					this.newDeviceId = response.data.id;
					this.retrievePrice();
				})
				.catch((error) => {
					this.newProduct = '';
					displayError(error.response.data);
				})
				.finally(() => {
					this.findDeviceLoading = false;
				});
		},

		/**
		 * Update the insured device with the provided information
		 */
		updateInsuredDevice () {
			const orderrowToSend = {
				id: this.orderrow.id,
				productVersionId: this.orderrow.productVersionId,
				deviceId: this.newDeviceId,
				imei: this.newImei,
				ean: this.newEan,
				serialNumber: this.newSerialNumber,
				end: this.orderrow.end
			};

			axios.post('/bo/orders/insureddevice', {
				orderrow: orderrowToSend
			}).then(() => {
				this.dialog = false;
				inform(this.$gettext('Insured device has been updated successfully'));
				debounce(() => {
					window.location.reload();
				}, 1000)();
			}).catch((error) => {
				let message;

				if (error.response && error.response.status === 400 && error.response.data) {
					message = error.response.data;
				} else {
					message = this.$gettext('Something went wrong while updating the insured device');
				}
				this.dialog = false;
				setTimeout(() => {
					displayError(message);
				}, 200);
			});
		}
	}
};
</script>

